import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriCartTotalsComponent } from '../../components/gonvarri-cart-totals/gonvarri-cart-totals.component';
import {GonvarriOrderSummaryModule} from "../gonvarri-order-summary/gonvarri-order-summary.module";
import {provideConfig} from "@spartacus/core";
import {OrderDetailsService, ReplenishmentOrderDetailsService} from "@spartacus/order/components";
import {GonvarriOrderSummaryComponent} from "../../components/gonvarri-order-summary/gonvarri-order-summary.component";
import {
  GonvarriOrderDetailTotalsComponent
} from "../../components/gonvarri-order-detail-totals/gonvarri-order-detail-totals.component";

@NgModule({
  declarations: [
    GonvarriCartTotalsComponent
  ],
  imports: [
      CommonModule,
      GonvarriOrderSummaryModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        CartTotalsComponent: {
          component: GonvarriCartTotalsComponent
        },
        ReplenishmentDetailTotalsComponent: {
          component: GonvarriOrderDetailTotalsComponent,
          providers: [
            {
              provide: OrderDetailsService,
              useExisting: ReplenishmentOrderDetailsService,
            },
          ],
        },
      }
    })
  ]
})
export class GonvarriCartTotalsModule { }
